// src/App.jsx
import React from 'react';
import Layout from '../../components/layout';
import { Link } from 'react-router-dom';

function qwikco() {
    return (
        <Layout>

        <div className="min-h-screen bg-gray-100 font-sans">
            {/* Header */}
            <header className="bg-gradient-to-r from-blue-700 to-indigo-600 text-white sticky top-0 z-10 shadow-lg">
                <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center">
                        <h1 className="text-2xl font-extrabold tracking-tight">Qwicko</h1>
                        <nav className="hidden md:flex space-x-8 items-center">
                            <a href="#features" className="hover:text-blue-200 transition duration-200">Features</a>
                            <a href="#advantages" className="hover:text-blue-200 transition duration-200">Advantages</a>
                            <a href="#integrations" className="hover:text-blue-200 transition duration-200">Integrations</a>
                            {/* <button className="bg-white text-blue-700 px-4 py-2 rounded-full font-medium hover:bg-blue-50 transition duration-200">
                                Get Started
                            </button> */}
                        </nav>
                    </div>
                </div>
            </header>

            {/* Hero Section */}
            <section className="pt-20 pb-32 bg-gradient-to-b from-blue-50 to-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid md:grid-cols-2 gap-12 items-center">
                        <div>
                            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
                                Revolutionizing Logistics with AI on ONDC
                            </h2>
                            <p className="mt-4 text-xl text-gray-600">
                                Quicko by ENS Enterprises is your smart logistics gateway—connecting buyers, sellers, and ONDC-enabled providers for fast, efficient, and scalable delivery solutions.
                            </p>
                            <div className="mt-8 flex space-x-4">
                                 <a href="https://www.qwikco.com/signup">
                                <button className="bg-blue-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-700 transition duration-200">
                                    Get Started
                                </button>
                                 </a>
                                 <a href="https://www.qwikco.com/">
                                <button className="border-2 border-blue-600 text-blue-600 px-6 py-3 rounded-full font-semibold hover:bg-blue-50 transition duration-200">
                                    Learn More
                                </button>
                                 </a>
                            </div>
                        </div>
                        <div className="hidden md:block">
                            <div className="bg-blue-100 rounded-xl p-8 shadow-lg">
                                <p className="text-blue-800 font-medium italic">"The Logistics Superconnector for India's Open Commerce"</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section id="features" className="py-20 -mt-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6">Powerful Features</h2>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        <FeatureCard
                            title="Unified Logistics Discovery"
                            description="Access multiple ONDC-approved providers like Loadshare, Dunzo, and Delhivery. Auto-match based on pin code, delivery type, and weight."
                            icon="🔍"
                        />
                        <FeatureCard
                            title="Real-Time Rate Comparison"
                            description="Compare rates, ETAs, and service types (same-day, next-day, standard) across providers. Book instantly with smart bundling."
                            icon="💰"
                        />
                        <FeatureCard
                            title="Intelligent Dispatch Engine"
                            description="AI suggests optimal LSPs based on success rates and cost. Auto-reroutes failed deliveries and supports reverse logistics."
                            icon="🤖"
                        />
                        <FeatureCard
                            title="Live Tracking"
                            description="Track shipments in real-time with automated SMS, WhatsApp, and app notifications. Includes proof of delivery."
                            icon="📍"
                        />
                        <FeatureCard
                            title="Business Dashboard"
                            description="Manage multi-location dispatches with real-time KPIs: on-time rates, costs, and courier performance."
                            icon="📊"
                        />
                    </div>
                </div>
            </section>

            {/* Advantages Section */}
            <section id="advantages" className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16">Why Choose Quicko?</h2>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                        <AdvantageCard
                            title="Smarter Selection"
                            description="Choose the best logistics partner per shipment—faster, cheaper, more reliable."
                        />
                        <AdvantageCard
                            title="Effortless Scaling"
                            description="Perfect for e-commerce, D2C brands, aggregators, and kirana stores."
                        />
                        <AdvantageCard
                            title="Cost Efficiency"
                            description="AI optimization reduces costs while improving delivery rates."
                        />
                        <AdvantageCard
                            title="ONDC Native"
                            description="Fully aligned with ONDC logistics specifications and ecosystem."
                        />
                        <AdvantageCard
                            title="Customer Trust"
                            description="Real-time tracking and accurate ETAs enhance customer satisfaction."
                        />
                    </div>
                </div>
            </section>

            {/* Integrations Section */}
            <section id="integrations" className="py-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16">Seamless Integrations</h2>
                    <div className="grid md:grid-cols-2 gap-12 items-center">
                        <div>
                            <ul className="space-y-4">
                                <li className="flex items-start">
                                    <span className="text-blue-600 text-2xl mr-2">•</span>
                                    <span>Integrates with seller apps, buyer apps, and ERP systems</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-blue-600 text-2xl mr-2">•</span>
                                    <span>API-ready for D2C platforms and order management systems</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-blue-600 text-2xl mr-2">•</span>
                                    <span>Ensures ONDC protocol compliance across the network</span>
                                </li>
                            </ul>
                        </div>
                        <div className="bg-blue-600 text-white p-8 rounded-xl shadow-lg">
                            <h3 className="text-2xl font-semibold mb-4">Plug & Play Solution</h3>
                            <p>Quicko seamlessly connects with your existing systems for automated order ingestion and dispatch management.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-20 bg-gradient-to-r from-blue-700 to-indigo-600 text-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="text-3xl md:text-4xl font-bold mb-6">
                        Join India's Logistics Revolution
                    </h2>
                    <p className="text-xl mb-8 max-w-3xl mx-auto">
                        Quicko bridges buyers, sellers, and logistics partners with AI-backed delivery systems that are fast, scalable, and reliable.
                    </p>
                    <Link to="/request-demo">
                    <button className="bg-white text-blue-700 px-8 py-3 rounded-full font-semibold hover:bg-blue-50 transition duration-200">
                        Start with Quicko Today
                    </button>
                    </Link>
                </div>
            </section>

            {/* Footer */}
            {/* <footer className="bg-gray-900 text-white py-10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid md:grid-cols-3 gap-8">
                        <div>
                            <h3 className="text-xl font-bold">Quicko</h3>
                            <p className="mt-2 text-gray-400">The Logistics Layer for ONDC</p>
                        </div>
                        <div>
                            <h4 className="font-semibold">Contact</h4>
                            <p className="mt-2 text-gray-400">support@quicko.in</p>
                            <p className="text-gray-400">+91-123-456-7890</p>
                        </div>
                        <div>
                            <h4 className="font-semibold">Powered by</h4>
                            <p className="mt-2 text-gray-400">ENS Enterprises</p>
                        </div>
                    </div>
                    <p className="mt-8 text-center text-gray-400">© 2025 ENS Enterprises. All rights reserved.</p>
                </div>
            </footer> */}
        </div>
        </Layout>

    );
}

// Feature Card Component
const FeatureCard = ({ title, description, icon }) => (
    <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition duration-200">
        <div className="text-3xl mb-4">{icon}</div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-gray-600">{description}</p>
    </div>
);

// Advantage Card Component
const AdvantageCard = ({ title, description }) => (
    <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition duration-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-gray-600">{description}</p>
    </div>
);

export default qwikco;